import React from 'react';

// This component now just renders its children without any protection
const ProtectedRoute = ({ children }) => {
  return children;
};

export default ProtectedRoute;